module.exports = __webpack_public_path__ + "img/cloud-drizzle.7ce1adaa.svg";